import { ServiceError, UserErrorResponse } from './serviceError';

export default class AlwaysFailServiceError implements ServiceError {
  async notifyUser(): Promise<UserErrorResponse> {
    return 'fail';
  }
}
